import { Typography } from '@dev/ee-components';
import styled from 'styled-components';

const NUMBER_CELLS_CUSTOM_CLASS = 'number-cell-layout';
const ACTION_CELL_CUSTOM_CLASS = 'action-cells-layout';
const STATUS_ITEM_CUSTOM_CLASS = 'status-cell-layout';
const PREVIEW_NAME_ITEM_CUSTOM_CLASS = 'overview-cell-layout';

export const customClassForColumnCells = {
    preview: PREVIEW_NAME_ITEM_CUSTOM_CLASS,
    campaignName: PREVIEW_NAME_ITEM_CUSTOM_CLASS,
    delivered: NUMBER_CELLS_CUSTOM_CLASS,
    opened: NUMBER_CELLS_CUSTOM_CLASS,
    clicked: NUMBER_CELLS_CUSTOM_CLASS,
    spaceColumn: STATUS_ITEM_CUSTOM_CLASS,
    status: STATUS_ITEM_CUSTOM_CLASS,
    viewReport: ACTION_CELL_CUSTOM_CLASS,
};

export const EllipsisTypography = styled(Typography)`
    word-break: break-all;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
`;

export const CampaignsCustomTableWrapper = styled.div`
    .MuiTableCell-root {
        font-weight: 400;
    }

    .MuiTypography-body1 a {
        white-space: nowrap;
    }

    .campaign-name {
        word-break: break-all;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        max-height: 65px;
        margin-bottom: 16px;
    }

    .MuiTableSortLabel-root {
        white-space: nowrap;
    }

    .single-row--cell {
        &.${NUMBER_CELLS_CUSTOM_CLASS},
            &.${ACTION_CELL_CUSTOM_CLASS},
            &.${STATUS_ITEM_CUSTOM_CLASS},
            &.${PREVIEW_NAME_ITEM_CUSTOM_CLASS} {
            vertical-align: top;
            line-height: 1.29;
        }

        &.${NUMBER_CELLS_CUSTOM_CLASS} {
            padding-top: 38px;
        }
        &.${ACTION_CELL_CUSTOM_CLASS} {
            padding-top: 30px;
        }
        &.${STATUS_ITEM_CUSTOM_CLASS} {
            padding-top: 34px;
        }
        &.${PREVIEW_NAME_ITEM_CUSTOM_CLASS} {
            padding-top: 20px;
        }
    }

    .MuiTableCell-body.MuiTableCell-paddingCheckbox {
        vertical-align: top;
        padding-top: 30px;
        line-height: 1.29;
    }
`;

export const MobileTableContainer = styled.div`
    margin-top: 24px;
    & > div {
        padding-bottom: 2px;
    }
`;
